<template>
  <div class="my-things">
    <!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 3100 1345"
      style="enable-background:new 0 0 3100 1345;"
      xml:space="preserve"
      class="card-full-round"
    >
      <g id="Layer_3">
        <g id="FbDKUg_1_">
          <image
            style="overflow:visible;"
            width="3100"
            height="1345"
            id="FbDKUg"
            :xlink:href="require(`@/assets/my-things/my-things2.jpg`)"
          ></image>
        </g>
      </g>
      <g id="Layer_2">
        <g id="IqIFFZ_1_">
          <g
            @mouseover="description = 'portal to the world (5yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M1028.3,568.7c0-20.3,0-40.7,0-61c0-9.8,0-19.6,0-29.4c0.3-75.8,0.7-151.6,1-227.4
              c0.1-35.3,0-70.6,0.1-105.9c0-5.1,0.5-10.4,1.9-15.3c4.4-15.2,14.9-23.4,30.7-23.7c22.3-0.3,44.7-0.2,67,0
              c14.1,0.1,28.3,0.8,42.4,0.8c99,0.4,197.9,0.7,296.9,1.1c69.5,0.3,139,0.6,208.4,1c45.3,0.3,90.6,0.6,135.9,1
              c18,0.1,30,11.6,30.4,29.7c0.8,41.3,0.1,82.6,0.3,123.9c0,15.8,0.6,31.6,0.8,47.4c0.1,5.8-0.7,11.6-0.7,17.4
              c-0.1,27.2-0.2,54.5-0.2,81.7c0,24.7,0.2,49.3,0.1,74c-0.2,50.6-0.7,101.3-0.9,151.9c0,9.6-3.2,18-8.6,25.6
              c-1.3,1.8-3.3,3.2-5.2,4.5c-9.9,6.3-20.7,8.4-32.4,8.1c-17.8-0.4-35.6,0.1-53.4-0.2c-11.5-0.2-22.9-1.8-34.4-1.8
              c-101.8-0.2-203.6,0-305.3-0.1c-30.1,0-60.2-0.7-90.3-0.8c-8,0-16,0.8-23.9,0.8c-38.5-0.2-77-0.6-115.4-0.9
              c-16.5-0.1-32.9,0.1-49.4,0c-20.3-0.2-40.6-0.2-60.8-1.1c-19.6-0.9-29.2-7.4-34.4-25.8c-0.6-2-0.6-4.3-0.6-6.4
              C1028.3,614.7,1028.3,591.7,1028.3,568.7C1028.3,568.7,1028.3,568.7,1028.3,568.7z"
            />
          </g>
          <g
            @mouseover="description = 'two-thirds-of-the-year shoes'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M296.4,646.8c-2.7,6.9-5,12.6-7.2,18.2c-6.4,16.6-14.2,32.3-25.1,46.4c-19.7,25.5-44.3,42.3-77.1,45.8
              c-24.1,2.5-47.3-0.1-68.6-12.3c-10.1-5.8-18.1-14.1-24.9-23.5c-13.6-18.7-24.2-39.1-31.9-60.8c-4.7-13.3-8.3-27-12.4-40.5
              c-1.5-4.9-3.4-9.8-4.6-14.8c-1.4-6-2.6-12-3.1-18.1c-0.8-8.6-0.8-17.3-1.3-25.9c-0.6-10.3-2.1-20.6-1.7-30.8
              c0.7-22.4,2.2-44.8,3.7-67.2c0.5-7.4,1.6-14.8,3.1-22.1c1.3-6.5-1.1-11.4-5.3-15.8c-7.9-8.4-16-16.5-23.8-25
              c-5.1-5.6-6.1-12.4-3.7-19.6c2.5-7.3,3.3-14.2,1.7-22.3c-1.9-9.6-1.1-19.9-0.2-29.8c0.5-6,4.6-10.6,11.3-11.7
              c1.3-0.2,2.6-0.6,3.9-0.8c6.4-1.2,7.6-2.8,6.9-9.5c-0.6-6-0.9-12-1.9-17.9c-2.1-12,1.1-23.5,2.6-35.2
              c3.1-25.3,11.5-49.2,19.9-73.1c4.2-11.9,7.4-24.2,10.5-36.5c3.9-15.5,7.8-31.1,15.6-45.2c4.4-8,11.1-14.7,16.9-22
              c2.4-3,5.2-5.6,7.5-8.5c5.1-6.3,10.6-11.3,19.3-12.8c29.2-5.2,57.5-1.2,84.9,8.9c8.5,3.1,15.8,9.1,23.9,13.3
              c5,2.6,10.4,4.3,15.5,6.5c1.5,0.6,3.2,1.3,4.3,2.4c3.7,3.8,6.6,2.4,9.7-0.8c5.6-5.7,11-11.6,17-16.8c12.8-11.2,28.4-15.7,44.9-17
              c16.1-1.3,31.9,1,47.3,5.8c1.9,0.6,3.8,1.3,5.6,2.2c13.7,6.1,27.6,11.8,40.9,18.6c10.1,5.1,19.5,11.3,29.1,17.2
              c2.4,1.5,4.3,3.7,6.7,5.2c11,7.2,18.1,17.5,23.9,28.9c10.2,20.2,14.8,42,18,64.2c3.7,25.9,6.7,51.8,10.8,77.6
              c3.9,25,7.8,50,13.7,74.6c4.9,20.5,12.2,40.5,19,60.5c13.7,40.7,22.4,82.1,19.7,125.5c-2.6,42-13,81.9-30.2,119.9
              c-11.8,26-26.2,50.6-47.2,70.6c-7.3,7-15,13.7-23.1,19.8c-12.6,9.3-27.9,10.9-42.7,12.2c-12,1.1-24.4,0.7-36.4-1.1
              c-12.6-1.9-24.6-7.2-34.3-15.4c-12.8-10.7-24.1-23-30.3-39.1c-6-15.5-12.3-30.9-18.4-46.3C298.2,651.3,297.5,649.6,296.4,646.8z"
            />
          </g>
          <g
            @mouseover="description = 'yoga block'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M988.5,251.5c0,11.2,0,22.3,0,33.5c0,38.5-0.2,76.9,0.1,115.4c0.2,19.5,1.7,38.9,1.7,58.4
              c0,19.8-1.3,39.6-1.7,59.4c-0.1,6.6,0.9,13.3,0.8,19.9c-0.2,30.1-0.6,60.2-1.1,90.3c-0.1,3.9-0.6,8-1.9,11.8
              c-4.5,13.7-12.7,19-27.4,20c-54.3,3.8-108.6,1.6-162.9,1.8c-58.9,0.2-117.9-0.5-176.8-0.9c-6.5,0-12.9-0.8-19.4-1.2
              c-13.5-0.8-24.1-12.9-23.8-27.5c0.5-24.8,0.1-49.7,0.1-74.5c0-17.3,0.1-34.6-0.1-51.9c-0.2-17.5-0.8-34.9-0.9-52.3
              c-0.1-63,0.1-125.9-0.1-188.9c-0.1-34.6-0.5-69.3-1-103.9c-0.1-7-0.7-14-1.7-20.9c-0.9-5.6,1.5-9.9,4.5-13.8
              c7.4-9.5,16.7-15.4,29.4-15.3c20.7,0.3,41.3,0.1,62,0c64.8-0.3,129.6-0.8,194.4-0.9c20.4,0,40.8,1.3,61.2,2.1
              c4.9,0.2,8.9,2,12.8,5.6c10.5,9.9,21.7,19.2,32.5,28.8c4.7,4.2,9.2,8.7,13.7,13.1c4.3,4.1,5.4,9.3,5.4,15
              C988.4,200.2,988.4,225.8,988.5,251.5C988.4,251.5,988.5,251.5,988.5,251.5z"
            />
          </g>
          <g
            @mouseover="description = 'swimming gear (6yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M49.8,1161.2c0.7-2.7,1.2-6.5,2.6-10c7.3-18.1,10.1-37.2,12.8-56.3c0.3-2.3,0.4-4.7,1.1-6.9
              c3.4-11.9,0.4-23.3-2-34.9c-2.4-11.9-4.8-23.9-5.4-36c-1.1-23.4-2.6-46.9,4.2-70c1.3-4.2-0.2-9.5-1.1-14.1
              c-2.7-13.4-2.3-25.8,3.7-38.8c5.1-11,6.4-23.7,9.4-35.6c1.3-5.3,3-10.6,4.1-16c1.5-7.5,7-10.9,13.3-12.6
              c5.5-1.5,11.5-1.8,17.3-2.1c4.3-0.2,8.2-0.8,11-4.6c1.2-1.5,2.9-2.8,4.6-3.8c13.9-7.4,27.5-15.9,42.1-21.7
              c9.1-3.7,19.8-3.4,29.9-4.8c2-0.3,4.1,0.2,5.9-0.4c15.4-4.3,31.1-3,46.7-2.5c14.3,0.5,28.6,1.1,42.9,1.5
              c12.3,0.4,24.6,0.9,36.9,0.9c10.8,0,21.6-0.7,32.4-0.9c5.3-0.1,10.6,0.9,15.9,0.7c5.9-0.2,11.8-1.5,17.7-1.7
              c9.4-0.3,19.1-1.3,28.3,0.3c15,2.8,29.9,4.5,45.1,2.5c10.5-1.3,14,4,16.9,13.1c2.4,7.5,2.4,15.7,3.2,23.6c0.5,4.3,0.7,8.6,0.6,13
              c-0.2,7.9,4.6,13.2,9.3,18.7c8.2,9.4,15.9,19.3,24.7,28.1c6,6.1,13.2,11.2,20.3,15.9c9.9,6.6,10.1,6.5,6.9,17.9
              c-0.4,1.6-0.1,3.6,0.5,5.2c5.1,13.1,9.5,26.2,10.2,40.5c0.3,6.1,3.5,12.1,5.8,18c2.7,6.9,3.5,13.8,1.5,21
              c-2.9,10.9-5.3,22-8.8,32.8c-2.3,7.2-1.7,14.1-0.5,21.2c2.6,14.9,5.3,29.8,7.9,44.7c0.3,1.8,0.7,3.6,0.6,5.4
              c-0.7,14.9,1,29.6,4.5,44.1c1.1,4.7,2.4,9.4,2.9,14.1c0.4,4.1,0.4,8.3-0.5,12.3c-0.5,2.2-2.8,4.5-4.9,5.7
              c-12.5,7.2-25,14.5-38,20.9c-6.3,3.1-13.5,5.2-20.5,5.8c-18.7,1.8-35.4,9.3-51.6,17.8c-10.7,5.6-21.4,8.6-33.6,6.8
              c-4.8-0.7-9.9,0.6-14.9,0.9c-16.6,0.9-33.2,2.5-49.8,2.5c-12.9,0-25.8-2-38.7-3.4c-3.9-0.4-7.2-0.1-9.9,3.1
              c-6.1,7.4-14.3,9.4-23.6,9.6c-11.3,0.2-22.5,1.7-33.8,2c-11.6,0.3-23.3-0.1-34.9-0.4c-9-0.3-17.9-1.1-26.9-1.6
              c-9.8-0.6-20,0.5-29.3-1.9c-13.8-3.5-27.2-8.8-40.3-14.3c-15.3-6.5-30.3-13.9-45.3-21.1c-7.2-3.5-13.3-8.5-16.6-15.9
              c-4.2-9.2-7.9-18.7-11.4-28.2C50.2,1168.9,50.4,1165.5,49.8,1161.2z"
            />
          </g>
          <g
            @mouseover="description = 'sketchbook'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2566.9,745.1c-13.7,0-27.3,0-41,0c-14,0-27.9,0-41.9,0c-6.8,0-7.7-0.9-7.7-7.9c0-0.3,0-0.7,0-1
              c-0.3-62.3-0.7-124.6-1-186.9c-0.3-59.6-0.6-119.3-1-178.9c-0.1-10.9-0.9-21.9-0.9-32.8c0.1-21.1,0.5-42.3,1-63.4
              c0.2-7.5,3.4-10.4,12.1-12c1.1-0.2,2.3-0.2,3.5-0.2c33.6-0.4,67.3-0.7,100.9-1.1c21.5-0.3,43-0.7,64.4-1
              c17.1-0.3,34.3-0.5,51.4-1c13.3-0.4,26.5-1.6,39.8-1.9c9-0.2,18,0.3,26.9,1c8.7,0.7,15.1,5.7,20.5,12.2c0.9,1,1.2,2.8,1.3,4.2
              c0.5,9.1,1,18.3,1.1,27.4c0.2,16.2,0,32.3,0.1,48.5c0.3,51.1,0.6,102.3,1,153.4c0.3,36.6,0.6,73.3,1,109.9
              c0.2,20.8,0.6,41.6,1,62.4c0.3,14.1,0.1,28.3,1.1,42.4c0.9,12.8-8.9,20.9-17.8,22.5c-10.9,2-22.1,3.8-33.1,3.9
              c-40,0.2-80-0.5-119.9-0.8c-21-0.1-42,0-62.9,0C2566.9,744.4,2566.9,744.8,2566.9,745.1z"
            />
          </g>
          <g
            @mouseover="description = 'take-anything-apart kit (5yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M1263.3,857c0,34,0.1,68,0,102c-0.2,56.8-0.6,113.6-0.8,170.4c-0.1,19.6,0,39.3-0.1,58.9
              c0,3.8-0.4,7.6-0.8,11.4c-0.9,6.9-4.2,10.7-11.1,11.3c-11.1,1-22.2,1.8-33.4,1.8c-56.2,0.2-112.3,0.2-168.5,0.3
              c-8.9,0-13.1-4.8-14.4-13.6c-5.9-39.8-2.4-79.8-2.7-119.6c-0.5-65.6,0.4-131.3,0.8-196.9c0.1-18.3,0.8-36.6,0.9-54.9
              c0.2-22.5,0-44.9,0.1-67.4c0-12.9,7.9-20.8,20.6-20.8c64.7,0,129.3,0,194,0c11.4,0,15.7,4.3,15.7,15.7c0,33.8,0,67.7,0,101.5
              C1263.5,857,1263.4,857,1263.3,857z"
            />
          </g>
          <g
            @mouseover="description = 'zojirushi thermos (2yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2868.3,631.2c0-25.6,0.2-51.3-0.1-76.9c-0.2-13.6-1.3-27.2-1.8-40.9c-0.1-4.5,0.9-8.9,0.8-13.4
              c-0.1-11-0.8-22-0.9-32.9c-0.2-18.8,0.1-37.6-0.1-56.4c-0.1-11.8-0.8-23.6-0.9-35.4c-0.1-19.6,0.2-39.2,0-58.9
              c-0.2-19.3-0.6-38.6-1-57.9c-0.4-15.9,3.4-31.1,8.1-46c2.9-9.4,3-18.6,2.6-28.1c-0.8-18.4-0.9-36.8,7.3-53.8
              c2.4-4.9,7.6-8.6,11.9-12.4c9.3-8.3,21.1-11.5,32.7-14c15.4-3.3,31.4-4,46.7-7.6c10.7-2.5,20.5-0.2,30.4,1.7
              c15.9,3,23.5,13.1,25.6,32.2c0.7,6.6,2,13.2,3.1,19.7c0.3,1.6,0.6,3.5,1.5,4.7c7.4,8.8,5.9,19.8,7.3,30c0.5,3.8,0,7.7,0.1,11.5
              c0.1,3-0.6,5.4-3.6,7c-1,0.5-1.9,3.2-1.5,4.3c6.9,19.4,7.2,39.4,7.2,59.7c-0.1,32.1,0.5,64.3,0.9,96.4c0.3,22.6,0.6,45.3,1,67.9
              c0.3,17.6,0.7,35.3,1,52.9c0.4,21.5,0.6,43,1,64.4c0.3,18,0.4,36,1.1,53.9c0.7,18.4,2.1,36.8,2.7,55.3c0.3,7.5-0.1,15-1.2,22.4
              c-0.4,2.4-3.9,5.6-6.5,6.2c-5.3,1.2-10.9,1.3-16.4,1.3c-40.6,0.4-81.3,0.8-121.9,1c-9.1,0-18.3-0.3-27.4-1.2
              c-2.2-0.2-5.3-2.5-6-4.6c-1.5-4.5-2.4-9.4-2.5-14.1c-0.3-12.7-0.1-25.3-0.1-38C2868.9,631.2,2868.6,631.2,2868.3,631.2z"
            />
          </g>
          <g
            @mouseover="description = 'yoga strap'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M734.3,871.1c-0.3-5.5-0.7-11-1-16.4c-0.8-10.9,2.8-20.3,9.7-28.6c8.4-9.9,17.8-18.6,30-23.5
              c2.7-1.1,5.8-1.1,8.7-1.3c1.5-0.1,3,0.6,4.4,0.4c14.1-1.8,24.7,4.8,34.4,13.9c5.3,5,5.8,5,10.5-0.7c10.6-12.7,24.4-18.1,40.7-17
              c2.5,0.2,4.9,2.3,7.2,3.8c6.7,4.5,11.3,10.9,14.5,18.1c2.1,4.8,5.5,7.3,10.5,8.1c3.8,0.6,7.5,1.4,11.3,2.1
              c15.5,2.9,15.7,7.8,13.7,23c-0.3,2.1-1,4.2-1.2,6.3c-0.4,3.1,0.6,4.7,4.1,6c6.4,2.6,8.4,9,9.7,15.3c0.6,3.1,0.6,6.3,1,9.4
              c0.6,5.4-1,10.2-3.2,15.3c-8.7,20-18.9,39.3-23.1,61c-5.2,26.6-10.7,53.2-15.9,79.8c-4.6,23.5-8.7,47.1-13.8,70.5
              c-5.2,23.8-16.8,44.7-32.4,63.3c-3.4,4.1-7.3,7.7-10.7,11.9c-8.9,10.8-20.1,18.5-32.9,23.6c-10.1,4-21,6.2-32.2,5.4
              c-19.7-1.5-38.8-5.3-55.7-15.8c-10.4-6.4-19.6-14.8-29.6-21.9c-7.8-5.6-12-13.6-15.6-22c-5.8-13.6-13.5-26.3-16.9-41
              c-7.3-31.6-15.1-63.1-22.7-94.7c-4.3-17.8-8.4-35.6-12.6-53.4c-3.8-16.4-5.6-32.9-2.6-49.5c3.4-19.2,16.1-30.8,33.1-38.4
              c7.4-3.3,14.9-6.6,22.4-9.6c1.6-0.6,3.6-0.5,5.4-0.3c5.6,0.9,11.2,1.9,16.6,3.3c4,1,8.1,2.2,11.6,4.2c5.5,3.1,11.4,2.9,17,1.7
              c2.2-0.5,4.1-4.2,5.4-6.8c0.8-1.4,0.1-3.6,0.1-5.4C734.2,871.1,734.3,871.1,734.3,871.1z"
            />
          </g>
          <g
            @mouseover="description = 'X-T2 (2yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2379.5,251.7c0.7,5,1.5,10,2,15.1c0.1,1.2,0,3-0.8,3.8c-3.8,4.2-3,9.2-3.4,14.2c-0.5,6.4-1.5,12.8-2.3,19.3
              c-0.5,4.4-1.2,8.9-1.5,13.3c-0.7,11.1-1.2,22.3-1.7,33.4c-0.4,8.6-0.6,17.2-1.3,25.8c-0.3,3-1.9,5.9-2.8,8.9
              c-0.4,1.4-0.5,2.8-0.5,4.2c0,5.5,1.1,11.2-0.1,16.4c-2.3,9.7-8.7,16.5-18.4,19.9c-5.3,1.9-10.5,4.2-15.8,5.8
              c-3.3,1-6.8,1-10.3,1.4c-12.2,1.2-24.5,2.8-36.8,3.4c-3.6,0.2-7.9-1.5-10.8-3.7c-5.4-4.1-11.6-5.1-17.5-4.6
              c-11.6,1-21.9-3.4-32.5-6.4c-8.7-2.4-16.6-16.9-15.5-27.3c0.2-2.3,0.3-4.7,1.1-6.9c1.5-4,0-7.1-1.1-11
              c-1.8-6.1-0.8-13.1-0.6-19.7c0.1-4.3,1-8.6,1.3-12.9c0.9-12.1,1.7-24.2,2.5-36.3c0-0.6-0.2-1.3-0.3-2.7c-4,1.9-7.6,3.8-11.3,5.3
              c-7.7,3.1-15.3,6.4-23.2,9c-8.4,2.8-16.3,6.2-23.8,12.6c2.2-0.1,3.5-0.2,4.7-0.3c12.4-0.6,23.5,6.5,27.6,18.3
              c0.9,2.4,0.6,5.6-0.1,8.2c-1.2,4.3-3.3,8.3-4.8,12.6c-2.8,7.8,1.3,14.2,5.9,19c7.1,7.4,10.3,16.1,12.4,25.6
              c1.8,7.9,4.4,15.7,5.8,23.8c2.6,14.7-3.8,28.4-17.2,35.3c-4.9,2.5-11.2,2.4-16.9,3.2c-1.1,0.2-2.9-0.8-3.4-1.7
              c-2.4-4.4-6.6-4.9-10.8-6.1c-16.2-4.6-27.2-15.7-35.3-29.8c-4.1-7-7.5-14.5-10.3-22.1c-1.9-5.2-2.1-11.1-3.4-16.6
              c-1.3-5.6-2.9-11.1-4.6-16.6c-0.9-3-2.2-5.9-3.6-8.8c-3.6-7.4-7.7-14.7-11-22.2c-2.1-4.8-3.6-10-4.8-15.1
              c-1.9-8.5-2.5-17.5-5.3-25.7c-3.2-9.2-4.4-18.4-3.8-27.9c0.7-10.1,1.5-20.2,2.9-30.3c0.5-3.8,3-7.3,4.1-11.1
              c1.2-4,2.8-8.3,2.5-12.4c-1.4-22.3-0.9-44.2,6.9-65.5c4.7-13.1,12.7-21.6,26.9-23.6c13.1-1.9,25.8-5.4,39.4-1.3
              c6.8,2,14.8,0.4,22.3-0.1c8-0.5,15.9-2,23.8-2.1c8.9,0,18.1,0.3,26.8,2c11.2,2.3,22.2,0.5,33.3,0.8c3.4,0.1,4.3-1.8,4.1-4.7
              c-0.2-4.1,1.6-6.3,5.9-6.3c8.3,0.1,16.6-0.5,24.8,0.2c19.5,1.8,38.9,0,58.3-1.6c9.2-0.8,18.6-0.2,27.9,0.5
              c2.3,0.2,5.6,2.4,6.4,4.5c1.8,4.6,5,5.1,9,5.4c8.8,0.6,17.6,1.5,26.3,2.2c4.9,0.4,8,2.6,8.8,7.9c0.2,1.7,1.8,3.7,3.3,4.6
              c12.4,6.9,16.5,17.4,14.1,31.1c-0.6,3.2-0.1,6.6,0.3,9.9c0.2,1.2,1.4,2.6,2.5,3.2c6,3.2,6.7,12.1,0.6,15.7
              c-4.1,2.4-6.4,5.4-7.2,10.1c-2.1,13.1-11.5,18.5-24.8,19.4c-11.6,0.7-23.2,0.2-34.8,0.3c-1.5,0-3.5,0.7-4.3,1.8
              c-1.8,2.4-3.1,5.2-4.6,7.9C2380.3,253.2,2379.9,252.4,2379.5,251.7z"
            />
          </g>
          <g
            @mouseover="description = 'QC35 (2yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2070.9,712.5c0-24.7,3.3-48.8,11.2-72.3c0.9-2.7,2.2-5.2,3.4-7.8c0.9-2.1,2.6-4.3,2.6-6.4
              c0-9.9,5.8-17.5,9.9-25.7c14.6-29.2,38.9-48,66.6-63.3c16.8-9.2,34.8-14.9,53.8-17.2c15.5-1.9,31.1-4,46.6-3.7
              c29.9,0.5,58.1,8.5,84.4,23c20.7,11.4,39.4,25.3,53,44.7c8.2,11.7,15.2,24.7,20.6,38.1c6.8,17.1,12.6,34.8,16.7,52.7
              c4.7,20.4,6.1,41.5,3.9,62.5c-1.2,11.7-2.6,23.5-4.6,35.1c-3.4,19.8-12.3,37.2-24.2,53.2c-8.1,10.8-11.8,22.8-13.6,36.3
              c-4.1,32-13.1,62.7-30.9,90c-6.2,9.6-13.8,18.9-26.4,20.5c-7,0.9-14.2,0.4-21.4,0.4c-2.3,0-4.7-0.6-7-0.5
              c-10.3,0.7-20.5,1.7-30.8,2.5c-3,0.2-6,0.3-9,0.2c-12.8-0.5-25.6-0.9-38.3-1.8c-8.3-0.6-16.4-2.1-24.7-3.1
              c-2.6-0.3-5.3,0.1-7.9-0.1c-9.1-0.6-18.2-1-27.3-2.1c-1.9-0.2-3.7-2.6-5.2-4.3c-18.1-21.9-30.5-47.1-41.5-73.2
              c-1.8-4.3-2.7-8.9-3.6-13.5c-2.8-13.4-9.2-24.9-18.7-34.7c-1.3-1.3-2.7-2.7-3.4-4.3c-7.6-16.2-18-31.1-23.1-48.6
              c-5-17-8.9-34.1-10-51.7C2071.8,729.1,2071.3,720.8,2070.9,712.5z M2253.8,820.5c1.4-2.8,2.1-4.3,2.7-5.7
              c3.2-7.5,5.9-15.2,9.6-22.4c8.8-16.9,18.6-32.9,35.3-43.8c9.9-6.5,28.3-7.9,37.2,0.8c3,2.9,6.2,5.8,9.9,7.5
              c8.9,4.1,13.9,11.4,18.7,19.4c3.4,5.6,9.6,7.5,15.7,8.3c1.6,0.2,4.5-2.1,5.1-3.8c1.3-4.2,2.1-8.7,2.1-13.1
              c0-5.3,1.7-9.1,5.4-12.8c2.5-2.5,5.1-6.2,5.4-9.6c0.9-11.2,1.7-22.6,1-33.9c-1.3-20.2-5.9-39.8-12.6-58.9
              c-4.8-13.9-12-26.2-24.6-34.2c-23.3-14.9-47.4-28.5-74.5-35.5c-28.7-7.4-57.6-10.3-86.2-1c-19.3,6.3-37.8,14.9-57,21.5
              c-13.9,4.8-20.5,16.3-28.5,26.8c-0.8,1.1-0.9,2.8-1.2,4.3c-0.8,5.1-1.1,10.3-2.4,15.3c-5.7,21.6-8.8,43.4-7.4,65.7
              c0.5,7.7,2.3,15.4,3.6,23.1c0.2,1.2,0.9,2.9,1.9,3.3c8.7,3.8,9.6,11.3,9.3,19.2c-0.2,5.6,2.3,9.9,5.7,14c2.2,2.6,4.6,3.5,7.9,2
              c7-3,13-6.7,17.5-13.3c3.1-4.5,8-7.7,12.2-11.3c1.6-1.4,4-2.1,5.2-3.8c5.9-7.9,14.2-8.5,22.9-7.6c6.9,0.7,12.8,2.9,18.3,8
              c13.3,12.5,21.6,28.2,29.5,44.2C2245.8,801.6,2249.3,810.4,2253.8,820.5z"
            />
          </g>
          <g
            @mouseover="description = 'laptop stand'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M1949,919.6c-2.1,5.3-7.5,4.5-12.7,4.6c-8.3,0.2-16.6,0.8-24.9,0.9c-8.6,0.2-14.4-5.4-15.1-13.9
              c-0.6-7.6-2-15.3-1.8-22.9c0.4-13.3,1.6-26.5,3-39.7c0.3-2.4,2.6-5.1,4.6-6.8c4.5-3.8,6-8.8,6.1-14.2c0.2-10.5,0-21,0.1-31.5
              c0-3.7-1.1-6-5.3-6.2c-3.7-0.2-5.7-2.6-5.6-6.3c0.2-16,0.5-32,0.7-47.9c0-3.2,0.2-6.3,0.2-9.5c0.3-34.8,0.6-69.6,1-104.4
              c0.3-27.6,0.6-55.3,1-82.9c0.3-19.6,0.7-39.3,1-58.9c0.3-20.6,0.6-41.3,1-61.9c0.2-12.3,1.2-24.6,0.9-36.9
              c-0.6-23.6-2.6-47.2-2.6-70.8c0-13.4,3-26.7,4.2-40.1c1.4-15.2,2.7-30.5,3.2-45.7c0.2-4.5-2.7-9.1-3.4-13.8
              c-0.9-5.4-0.9-10.9-1.3-16.4c-0.3-4.3,0.4-7.9,5.2-9.6c1-0.3,1.9-2.3,2-3.6c0.4-9.1,0.7-18.2,0.9-27.3c0-1,0-2.3-0.6-2.9
              c-5.8-6.2-4.2-13.6-3.4-20.9c1.7-16.5,3.5-18,19.9-18c6.3,0,12.7,0.1,19,0c5.1-0.1,9.7,0.5,12.9,5.8c3-5.6,7.8-5.9,13-5.8
              c9.3,0.2,18.7,0.1,28,0.2c6.1,0.1,8.4,2.3,9.3,8.1c4.4,27.8,3.2,55.7,2.2,83.7c-0.3,9,0.4,18,0.5,26.9c0,6-0.6,11.9-0.7,17.9
              c-0.1,17-0.2,34,0,51c0.2,17.9-3.6,35.4-5.8,53c-1.9,15.5-1.8,31.2-2.2,46.8c-0.6,24.5-0.8,49-1.1,73.4
              c-0.4,32.1-0.7,64.3-1,96.4c-0.4,46-0.3,92-1.2,137.9c-0.5,21.8-3.2,43.4-4.5,65.2c-1.1,18.9-1.6,37.9-2.2,56.9
              c-0.2,5.3,1.4,9.9,6.5,13.1c6.5,4.1,6.1,11.5,7,18c2.5,18.5,1.9,36.9-2.5,55c-2,8.5-4.9,10.8-13.5,10.7
              c-10.6-0.2-21.3-0.3-31.9-1.2C1955.8,924.6,1952.7,921.6,1949,919.6z"
            />
          </g>
          <a
            href="https://www.amazon.com/Kai-8-inch-Dressmaking-Shears-N5210/dp/B004MN72VG"
            target="_blank"
            rel="noreferrer"
          >
            <g
              @mouseover="
                description = `the best pair of scissors I've ever owned`
              "
              @mouseout="description = '???'"
              class="outline hasLink"
            >
              <path
                class="st0"
                d="M2440.4,1106c7.5-1.2,15-2.9,22.6-3.3c15.3-0.9,30.7-2.7,45.8-1.1c9,0.9,19,5.9,25.7,12.1
                c5.3,5,7,14.4,8.8,22.2c1.1,4.8-0.3,10.2-1.1,15.3c-1,6.5-4.3,11.7-8.8,16.9c-15.7,17.9-36.7,26.1-58.3,33.2
                c-29.5,9.7-59.9,14-91,12.8c-10.2-0.4-19.8-3.3-28.2-9c-13.2-8.9-27.5-14.8-43.3-16.9c-1.3-0.2-2.7-0.2-3.9-0.7
                c-4-1.7-6.2-0.5-7.4,3.6c-1.2,4-4.2,5.2-8.1,5c-21.8-0.7-43.6-2-65.3-1.9c-50.8,0.3-101.6,1.2-152.3,1.9
                c-12.1,0.2-21.2-7-31.2-12.2c-0.4-0.2-0.7-0.7-1-1.1c-2.2-3.5-0.6-18.6,1.8-22.1c7.3-10.8,18.5-12.6,30.1-13.7
                c14.5-1.4,29.1-2.6,43.7-3.8c13.9-1.1,27.8-2.2,41.8-3.2c22-1.6,44.1-2.9,66.1-5c19-1.8,37.9-4.5,56.9-7.1
                c6.4-0.9,12.7-2.6,19-4.1c1.4-0.3,2.8-1.2,3.7-2.3c4.7-5.5,9.5-10.6,11.7-18.1c1.5-5.4,6.7-9.7,10.2-14.6
                c9.4-12.7,19.1-25.2,28-38.3c11.5-17.1,25.6-31,44.6-39.5c3.7-1.7,7.9-2.5,12-3.3c23.6-4.5,42.3,3.7,57.5,21.8
                c9.2,11,13.6,24,16.9,37.4c2.1,8.4-2.9,18.3-10.5,22.3c-10.7,5.7-21.2,11.9-33.4,14.2c-1.1,0.2-2,1-3,1.5
                C2440.2,1105.2,2440.3,1105.6,2440.4,1106z"
              />
            </g>
          </a>
          <g
            @mouseover="description = 'microfiber cloth'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2826.6,725.3c31.3,0.6,62.6,1.3,93.8,1.8c18.5,0.3,37,0.6,55.4,0.7c3.6,0,7.3-0.6,10.9-0.8
              c4.1-0.3,7.9,0,10.9,3.5c0.7,0.9,2.3,1.1,3.6,1.5c5.8,1.6,7.4,4.8,5.4,10.5c-0.6,1.5-1.3,3.1-1.3,4.7c0.3,23.3,0.3,46.6,1.2,69.9
              c0.8,23.3,2.5,46.5,3.6,69.7c0.1,2.7-1.4,5.5-2.1,8.3c-0.6,2.8-1.5,5.7-1.5,8.5c-0.1,9-2.6,10.5-11.3,8.6
              c-5.1-1.1-11.3-1.2-16,0.7c-6.7,2.8-13,1.7-19.6,1.8c-4.6,0.1-9.3,0.2-13.9,0.2c-4.2,0-8.4-0.3-12.6-0.5c-0.8,0-1.7-0.3-2.5-0.1
              c-20.6,4.3-41.4,1-62.1,1.9c-5.1,0.2-10.2,1.2-15.3,1.6c-2.1,0.2-4.4,0.3-6.4-0.3c-6.7-1.9-13-2.1-19.8,0.5
              c-4.1,1.5-9.2,1-13.8,0.4c-3.6-0.4-4.3-3.9-4-7.1c0.6-5.2-1-7.8-6.8-8.5c-6.7-0.8-9.3-4.2-9.1-10.8c1.1-26.1,2.4-52.1,3.7-78.2
              c0.6-12.8,1-25.6,2.2-38.3c0.9-9.5-0.3-19.2,4.2-28.4c2.1-4.2,1.3-9.8,1.6-14.8c0.4-5.2,2.1-7.2,7.3-7.4c4.7-0.2,9.3,0,14,0
              C2826.6,725.1,2826.6,725.2,2826.6,725.3z"
            />
          </g>
          <a
            href="https://www.sparkfun.com/tutorials/362"
            target="_blank"
            rel="noreferrer"
          >
            <g
              @mouseover="description = 'modded caliper with AA battery (6yr)'"
              @mouseout="description = '???'"
              class="outline hasLink"
            >
              <path
                class="st0"
                d="M1511.5,826.4c-1.4,5.1-1.6,9.6-3.6,13.1c-5.5,9.3-14.6,12.5-25.1,9.3c-1.8-0.5-3-2.6-4.8-3.4
              c-1.7-0.7-4.6-1.3-5.4-0.5c-3.8,4.1-8.6,4.7-13.6,5.4c-8.8,1.3-17.6,1.8-25.8-2.7c-5.6-3-11.5-3.8-17.9-3.6
              c-11.2,0.3-22.3,0.2-33.5,0c-4-0.1-5.9,1.2-6.5,5.5c-0.7,4.9-2.4,9.7-3.9,14.4c-2,6.5-4.7,12.8-6.2,19.4
              c-3.8,16.3-10.6,19-26.1,17.3c-5.9-0.7-11.1-2.8-13.2-9.6c-6-18.7-13.8-36.9-17.9-56c-2.8-12.9-0.7-26.9-0.7-40.4
              c0-6.7-0.7-13.5,0.8-19.9c2.4-10.5,6.2-20.7,9.8-30.9c1.4-4.1,10.7-4.3,14.5-0.2c2.8,3,5,6.6,7.5,9.8c0.7,0.9,1.5,1.9,2.5,2.2
              c11.7,3.4,23.5,6.1,35.9,4.5c3.1-0.4,6.3-0.3,9.5-0.3c5.5-0.1,10.3-0.3,14.5-5.6c4.7-6.1,17.8-4.4,21.9,2.3
              c2.1,3.4,4.7,4.9,8.2,4.2c9.9-2,19.8-4.4,29.7-6.6c1.5-0.3,2.9-0.9,4.3-1.1c5.9-0.9,8.6,1,7.9,6.8c-0.9,8.1,5.9,12.2,8.3,18.6
              c0.3,0.9,2.9,1.3,4.5,1.3c27.7,0.1,55.3,0.2,83,0c18.2-0.1,36.3-0.6,54.5-0.9c21-0.4,42-0.7,63-1c19.7-0.3,39.3-0.7,59-1
              c28.5-0.4,57-0.7,85.5-1c10.4-0.1,13.7,4.2,12.1,14.4c-1.2,7.4-1.7,14.9-2.5,22.3c-0.5,4.8-2.7,7.5-8,7.6
              c-7.5,0.1-14.9,0.8-22.4,0.9c-39.6,0.4-79.3,0.7-118.9,1.1c-24.6,0.2-49.3,0.6-73.9,1c-21.8,0.3-43.6,0.5-65.4,1.1
              c-13.3,0.3-26.6,1.2-39.9,1.9C1512.2,826.1,1511.4,826.4,1511.5,826.4z"
              />
            </g>
          </a>
          <g
            @mouseover="description = 'post-it'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2659.9,1208.1c-25.5,0-51,0-76.5,0c-6,0-11.9,0.1-17.9,0c-3.7,0-5.4-2.2-5.3-5.8c0-1.8,0-3.7,0-5.5
              c-0.7-33.3-1.4-66.6-2-99.8c-0.4-20.6-0.7-41.3-1-61.9c-0.1-9.6,3.2-12.2,12.6-10.8c2,0.3,4,0.5,6,0.5
              c52.3,0.3,104.6,0.7,156.9,0.9c10.5,0.1,11.5,1,11.6,11.8c0.4,22,0.7,43.9,1.1,65.9c0.6,31.9,1.3,63.9,1.8,95.8
              c0.1,8.1-0.6,8.7-8.9,8.7C2712.3,1208.1,2686.1,1208.1,2659.9,1208.1z"
            />
          </g>
          <g
            @mouseover="description = 'card holder (4yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M3017.5,1044.8c0,11.3-0.4,22.7,0.1,34c0.6,12.4-6.5,25.4-23.7,25.2c-24.5-0.3-48.9-1.2-73.4-1.7
              c-14.5-0.3-29-0.3-43.5-0.2c-23.1,0.2-46.3,0.4-69.4,1c-18.7,0.5-28.5-10.4-29.2-28.5c-0.2-5,0-10-0.1-15
              c-0.3-28.8-0.6-57.6-1.1-86.4c-0.1-5.2,1.8-8,6.6-9.6c4.3-1.5,8.4-3.9,12.7-5.6c2.1-0.8,4.5-1.1,6.8-1.1c41,0.3,81.9,0.6,122.9,1
              c20.8,0.2,41.6,0.9,62.4,0.9c8.6,0,15.2,4.5,22,8.4c2.5,1.4,4.4,6,4.6,9.3c1.3,22.8,2,45.5,2.9,68.3
              C3017.9,1044.8,3017.7,1044.8,3017.5,1044.8z"
            />
          </g>
          <g
            @mouseover="description = 'ambidextrous mouse'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M1881.4,1102.9c1.6-18.4,3.2-36.8,4.6-55.2c0.4-5,0-10,0.3-15c0.5-7.3,1.2-14.5,1.9-21.8
              c1.4-14.9,10.9-24.5,22.3-32c7.4-4.9,16-8,24.3-11.5c14.4-6.1,28.8-6.4,43,0.6c9.5,4.7,19.3,9,28.3,14.6
              c14.2,8.7,19.3,23.1,22.1,38.6c3.6,19.7,5.2,39.7,4,59.7c-0.9,14.9-3.3,29.7-5.3,44.5c-1.6,12.3-2.7,24.9-5.6,36.9
              c-2.5,10.4-8.4,19-17.8,25.5c-24.9,17.4-51.6,16.5-78.3,7.3c-19.9-6.9-31.3-23.2-36.7-43.2
              C1884.4,1135.9,1881,1119.7,1881.4,1102.9z"
            />
          </g>
          <g
            @mouseover="description = 'glasses'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2634.7,171.1c-5,6.8-9.6,13.9-15.1,20.4c-5.3,6.3-11.2,12.1-17.3,17.7c-6.4,5.9-14.9,6.5-23,6.8
              c-23.2,1-46.2-0.4-69.1-4.6c-1.8-0.3-4.5,0.7-5.8,2.1c-6.4,7.1-13.4,12.4-23.7,11.6c-4.2-0.4-7.1-2.4-6.4-6.5
              c0.9-5.1,1.9-10.8,4.9-14.8c7.5-10,6-21.1,5.6-32.2c-0.1-1.7-2.1-3.6-3.6-4.9c-1.8-1.5-4.1-2.2-6-3.5c-9.1-6.4-10.3-22.8-4-32
              c4-6,8.6-6.4,14.6-6.3c95,0.1,190,0.1,284.9,0.1c4.8,0,9.8-0.7,13,4.4c0.5,0.8,2.7,0.6,4.2,0.6c9.3,0.1,13.9,5.2,14.6,14.4
              c1,13.5-6,22.8-15.2,30.9c-8,7.1-12.9,15.5-13,26.3c0,1.5,0,3-0.3,4.5c-0.7,3.9-1.2,8.4-6,9.5c-4.9,1.1-9.7,1.8-13.9-2.6
              c-1.3-1.4-4.3-1.9-6.5-1.7c-7.4,0.7-14.8,2.6-22.2,2.8c-15,0.5-30,0.2-45,0.1c-7.8-0.1-14.8-2.2-18.9-9.7c-1.2-2.2-3-4-4.6-5.9
              c-2.6-3.2-5-5.4-9.9-3.6c-4.4,1.6-8.2-0.6-9.4-5.7c-0.7-2.9-1.3-5.8-1.5-8.8c-0.3-2.9-0.1-5.9-0.1-8.8
              C2635.8,171.4,2635.3,171.3,2634.7,171.1z"
            />
          </g>
          <g
            @mouseover="description = 'tape measure with mm & inch (2yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M1417.8,1047.3c-1.2-0.7-8.5-4.7-10.2-12.3c-0.7-3.2-0.3-6.3-0.2-6.6c0.4-2.3,1.7-4.5,2.7-6.7
              c0.3-0.7,1.1-1.2,1.7-1.8c6.9-8.1,6.9-8.1,17.1-4c7.8,3.2,15,7.2,20.7,13.6c10.7,12.1,22.1,23.6,31.9,36.4
              c8.3,10.8,14.3,23.1,13.2,37.8c-1.1,14.7,0,29.8-2.5,44.2c-2.5,14.6-7.7,28.9-18.9,40c-5.5,5.4-11.8,7.8-19.2,8.1
              c-0.5,0-1,0-1.5,0c-24.4-1-48.4,1.2-72.2,7.2c-8,2-17.4,3.2-24.6-2.5c-6.4-5-11.7-11.6-17.4-17.6c-1.2-1.3-2.1-3.2-3.6-4
              c-10.5-5.3-11.2-18.5-7.9-26.7c2.4-6.2,3.5-12.3,3.8-18.9c0.9-19.3,2.4-38.5,3.6-57.7c0.3-5.1,0.8-10.3,1.3-15.4
              c0.7-8.7,11.1-13.9,17.9-8.5c1.9,1.5,2.9,5.3,3,8c0.1,5.1-0.8,10.3-1.2,15.4c-0.2,2.6-0.4,5.2-0.6,7.8c0.7,0.5,1.3,0.9,2,1.4
              c3-3.5,6-7,9.1-10.4c9.5-10.3,22.6-11.2,29.2-12.2c4.7-0.7,12,1.9,20.5-0.2C1421.2,1060.4,1425.7,1055.4,1417.8,1047.3z"
            />
          </g>
          <g
            @mouseover="description = 'post-it pen'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2707.3,940.1c-15.8,0-31.7-0.2-47.5,0c-29,0.5-57.9,1.1-86.9,2.1c-18.6,0.6-37.2,2.2-55.8,2.7
              c-11.3,0.3-22.6-0.7-33.9-0.9c-11.8-0.2-20.5-11-20.8-22.6c-0.1-4,4.2-9.2,9-10.1c10.4-2.1,20.9-4.7,31.5-5.1
              c25.8-1,51.6-1,77.4-1.2c55.1-0.4,110.3-0.9,165.4-0.8c9.5,0,19.1,2.4,28.4,4.8c7.8,2,12,10.3,10.1,18.2c-0.4,1.6-1.7,3.3-3,4.4
              c-6.4,5.5-13.9,8.5-22.4,8.5C2741.7,940.1,2724.5,940,2707.3,940.1C2707.3,940.1,2707.3,940.1,2707.3,940.1z"
            />
          </g>
          <g
            @mouseover="description = 'sketchbook pen'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M2731.4,848.2c-25.9,0.6-51.9,1.2-77.8,1.9c-19.8,0.5-39.6,1-59.3,2c-12.6,0.6-25.1,2.4-37.7,3.3
              c-5.1,0.4-10.2-0.3-15.4-0.3c-11-0.1-22,0.4-33-0.1c-10.6-0.5-21.2-1.8-31.7-2.8c-4.3-0.4-8.6-0.9-12.9-1.1
              c-6.8-0.3-11.2-4.5-11.3-11.3c-0.1-2-0.1-4,0.2-6c1-7.2,2.7-9.2,9.9-10.1c10.1-1.2,20.2-2.3,30.3-2.7c23.4-0.9,46.9-1.9,70.3-2
              c69.6-0.3,139.2-0.1,208.7-0.1c6.5,0,8.4,1.8,8.7,8.1c0.2,4,0.1,8,0,12c-0.1,4.4-2.3,6.8-6.7,7.1c-14.1,0.8-28.2,1.6-42.3,2.4
              C2731.5,848.4,2731.4,848.3,2731.4,848.2z"
            />
          </g>
          <g
            @mouseover="description = 'keys + flash drive'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M3000.6,1188.4c-8.8-0.4-17.6-0.8-26.4-1.4c-3.6-0.2-5.5,1.1-6.3,4.7c-1.3,6.1-5.2,10-11.4,11.1
              c-4.9,0.9-8.1,3.9-11.5,7.3c-2.9,2.8-7.3,5.6-11.1,5.6c-11.7-0.1-23.5-1.4-35.2-2.7c-3.9-0.4-7.6-2.5-11.4-3.6
              c-3.5-1-7-1.9-10.6-2.4c-4-0.6-7.2-1.7-9.8-5.2c-1.1-1.5-3.8-2.7-5.8-2.7c-10.6,0-21.3,0.3-31.9,0.9c-8.9,0.4-14.3-5-18.9-11.1
              c-1.4-1.8-1.1-6.6,0.4-8.7c5.8-8.1,13.5-12.7,24.1-12.6c8.4,0.1,16.9-0.9,25.4-1.6c3.6-0.3,6-1.7,6.3-6.2c0.2-3.1,2-6.4,3.8-9.1
              c10.1-15,23.3-22.5,41.3-20.3c4.3,0.5,8.7,1,12.7,2.6c4.5,1.8,9.3,4,12.8,7.3c5,4.9,10.4,8.6,16.6,11.7c4.7,2.4,8.8,5.8,13.3,8.7
              c1.3,0.9,2.9,1.8,4.4,1.9c9.6,0.8,19.2,1.3,28.8,2.1c3.5,0.3,6.9,0.8,10.3,1.7c10.2,2.7,11.4,4.5,11,15c-0.1,4.3-2,6.5-6.4,6.5
              c-4.8,0-9.7,0-14.5,0C3000.6,1188.2,3000.6,1188.3,3000.6,1188.4z"
            />
          </g>
          <g
            @mouseover="description = 'cut-anything knife (6yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M1792.2,1084c0-32.3,0-64.6,0-96.9c0-4.8-0.5-9.6-0.9-14.4c-0.1-1.1-0.3-2.7-1-3.2c-4.9-3.2-4-8-3.9-12.6
              c0.3-29.6,0.7-59.3,1.1-88.9c0.1-7.4,1.5-8.8,8.8-8.8c7.3,0,14.7,0,22-0.1c4.4-0.1,6.3,2,6.3,6.4c-0.4,33-0.7,65.9-1.1,98.9
              c0,1.5-0.5,3.7-1.6,4.5c-4.2,3-4.3,7.1-4.3,11.5c0.1,43,0,85.9,0.1,128.9c0.1,25.5,0.5,50.9,0.8,76.4c0.1,8.1-2.2,10.3-10.3,10.5
              c-15.4,0.3-15.7,0-15.7-15.2C1792.3,1148.6,1792.3,1116.3,1792.2,1084C1792.3,1084,1792.3,1084,1792.2,1084z"
            />
          </g>
          <g
            @mouseover="description = 'tiny hands for those 0603s (6yr)'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M1705.5,1196.1c-9.9,0-13.6-3-14.6-12.8c-0.5-4.7,0.2-9.6,0.2-14.4c0-40.1,0.1-80.3,0-120.4
              c0-11.1-1.1-22.3-0.7-33.4c0.3-9.2,1.9-18.5,3.4-27.7c1.4-8.5,4-16.9,5-25.4c0.5-3.9-0.7-8.6-2.6-12.2
              c-3.4-6.5-7.8-12.4-11.7-18.6c-2.2-3.5-3.8-7.4-0.5-11c2.4-2.6,7.9-1.4,11.5,2.4c6.3,6.8,13,13.4,18.5,20.8
              c5.6,7.5,7.3,16.3,5.7,26c-1.4,8.5-3.9,18-1.6,25.6c7.5,24.1,4.8,48.4,4.8,72.8c0,25.3,0.4,50.6,0.5,75.9c0.1,11.5,0,23,0,34.5
              C1723.5,1191.9,1719.2,1196.1,1705.5,1196.1z"
            />
          </g>
          <g
            @mouseover="description = 'magnets'"
            @mouseout="description = '???'"
            class="outline"
          >
            <path
              class="st0"
              d="M1551.3,1184c0-3.2,0-6.3,0-9.5c-0.1-3.3,0.7-5.7,4.4-6.9c1.3-0.4,2.6-2.9,2.6-4.5c0-6,1-11.2,4.8-16.3
              c1.9-2.5,1.1-7.3,1-11.1c-0.4-11.5-1.2-22.9-1.8-34.4c-0.3-6-0.9-12-0.8-17.9c0.1-2.7,1.8-5.4,2.8-8c0.6-1.6,1.9-3.3,1.8-4.8
              c-0.4-13.6-0.8-27.3-1.6-40.9c-0.4-7.5,1.2-9.7,8.7-9.8c4.5-0.1,9-0.1,13.5,0c5.7,0.1,7.4,1.8,7.6,7.5
              c0.4,13.6,0.7,27.3,1.2,40.9c0.1,2.4,0.5,5.4,2,6.8c3.5,3.4,3.9,7.4,4,11.8c0.2,17.5,0.7,34.9,1,52.4c0.1,3.6,1.2,5.4,5.1,5.7
              c5.4,0.4,7.5,3,7.8,8.5c0.2,3,0,6,0.2,9c0.1,1.3,0.2,2.8,0.9,3.8c6.2,8.7,4.2,18.5,3.5,27.9c-0.3,4.1-3.8,6.8-8.6,6.8
              c-16.8,0.3-33.6,0.8-50.4,1c-7.2,0.1-9.6-2.4-9.6-9.6C1551.3,1189.7,1551.3,1186.8,1551.3,1184z"
            />
          </g>
        </g>
        <text
          transform="matrix(1 0 0 1 1550 1310)"
          text-anchor="middle"
          id="item-description"
        >
          {{ description }}
        </text>
      </g>
    </svg>
    <!-- <p id="item-description">{{ description }}</p> -->
  </div>
</template>

<script>
export default {
  name: "MyThings",
  props: {},
  data: () => ({
    description: "???"
  })
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-things {
  margin: 0rem;
  padding-top: 3rem;
  margin-bottom: -2px;
}
@media screen and (max-width: 600px) {
  .my-things {
    padding-top: 1rem;
  }
}
.outline {
  stroke-linejoin: round;
  fill-opacity: 0;
  stroke: white;
  stroke-width: 9px;
  stroke-opacity: 0;
  transition: var(--off-transition) stroke-opacity;
}
.outline:hover {
  stroke-opacity: 0.95;
  transition: var(--on-transition) stroke-opacity;
}
.hasLink:hover {
  cursor: pointer;
}
#item-description {
  text-align: center;
  font-size: 4rem;
  fill: var(--dark-color);
}
</style>
